import { FormField, FormRow, FormSection } from '../common'
import styles from './PostComposer.module.css'
import { CTA_OPTIONS, CRYPTODOTCOM_CTA_OPTIONS, OG_CTA_OPTIONS } from './ctaOptions'
import { isNavigationTargetAllowed } from '../../utils/navigationTargets'

export default function CtaSection({ isCryptoDotCom = false, isOG = false, ctaKind, ctaLabel, ctaTarget, onChange, embedded = false }) {
  const options = isOG ? OG_CTA_OPTIONS : isCryptoDotCom ? CRYPTODOTCOM_CTA_OPTIONS : CTA_OPTIONS
  const buttonPlaceholder = isOG ? 'e.g., Trade Pittsburgh' : isCryptoDotCom ? 'e.g., Buy LIV' : 'e.g., Bet Now'
  const targetPlaceholder = isOG
    ? 'OG market URL fallback'
    : isCryptoDotCom
      ? 'Crypto.com detail URL fallback'
    : ctaKind === 'provider-cart' ? 'Fallback URL' : 'e.g., sportsbook://bet/...'
  const ctaTargetError = ctaTarget && !isNavigationTargetAllowed(ctaTarget)
    ? 'Enter a valid URL or app deep link.'
    : undefined
  const fields = (
    <>
      <FormField
        label="CTA type"
        name="ctaKind"
        type="select"
        value={ctaKind}
        onChange={(event) => onChange('ctaKind', event.target.value)}
        options={options}
      />

      {(ctaKind === 'deep-link' || ctaKind === 'url' || ctaKind === 'provider-cart') ? (
        <>
          <FormField
            label="Button label"
            name="ctaLabel"
            value={ctaLabel}
            onChange={(event) => onChange('ctaLabel', event.target.value)}
            placeholder={buttonPlaceholder}
          />
          <FormField
            label="Target URL or deep link"
            name="ctaTarget"
            value={ctaTarget}
            onChange={(event) => onChange('ctaTarget', event.target.value)}
            placeholder={targetPlaceholder}
            error={ctaTargetError}
          />
        </>
      ) : null}
    </>
  )

  if (embedded) {
    return (
      <div className={styles.advancedGroup}>
        <h4 className={styles.advancedGroupTitle}>Call to action</h4>
        <div className={styles.advancedCtaGrid}>{fields}</div>
      </div>
    )
  }

  return (
    <FormSection title="Call to action" headingSize="subsection" description="Choose the action shown on the post card.">
      <FormRow>{fields}</FormRow>
    </FormSection>
  )
}
